import { createComposableRefinement } from '@/utils/structs/createComposableRefinement';

export const isValidWeekDay = (validWeekDayIndex: number) =>
  createComposableRefinement<string, null>(
    'isValidWeekDay',
    (value) => new Date(value).getDay() === validWeekDayIndex
  );
